import { change as changeFormValue } from 'redux-form';
import { connect } from 'react-redux';
import ProductBundle from '../components/ProductBundle';
import * as allProducts from '../../products';
const onChange = (dispatch, {
  form,
  options
}) => ({
  value
}, field) => {
  const selectedOption = options === null || options === void 0 ? void 0 : options.find(option => (option === null || option === void 0 ? void 0 : option.id) === value);
  const bundleProductIds = options.flatMap(option => option.features.map(feature => Number(feature.productTypeId)));
  const bundledProducts = Object.entries(allProducts).filter(product => bundleProductIds === null || bundleProductIds === void 0 ? void 0 : bundleProductIds.includes(product[1].id));
  if (bundledProducts.length > 0) {
    const formSections = bundledProducts.map(([, product]) => product.name);
    formSections.forEach(formSection => dispatch(changeFormValue(form, `${formSection}.value`, '')));
  }
  dispatch(changeFormValue(form, field, {
    productsInSelection: bundledProducts.map(p => p[1].id),
    value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type,
    price: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.priceRaw,
    id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id
  }));
};
const mapDispatchToProps = (dispatch, props) => ({
  onChange: onChange(dispatch, props)
});
export default connect(null, mapDispatchToProps)(ProductBundle);
//# sourceMappingURL=ProductBundleContainer.js.map